<div class="wa-inbox">
  <!-- Header -->
  <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
    <h4 class="mb-0 me-auto"><i class="fab fa-whatsapp text-success"></i> WhatsApp Inbox</h4>
    <select *ngIf="configs.length > 1" class="form-select form-select-sm w-auto" [ngModel]="selectedConfigId"
      (ngModelChange)="selectConfig($event)" [ngModelOptions]="{ standalone: true }">
      <option *ngFor="let c of configs" [ngValue]="c.waConfigId">+{{ c.phoneNo }} · {{ c.iName }}</option>
    </select>
    <span *ngIf="configs.length === 1" class="wa-pill">+{{ configs[0].phoneNo }} · {{ configs[0].iName }}</span>
  </div>

  <div *ngIf="configs.length === 0" class="alert alert-info py-2">
    No WhatsApp number is connected through Meta yet. Connect one on <a routerLink="/marketing/whatsapp/config">Marketing → Whatsapp → Config</a>.
  </div>

  <!-- thread-open: on phones only the open chat is shown (list comes back with the ← button) -->
  <div *ngIf="configs.length > 0" class="wa-body card" [class.thread-open]="!!selected">
    <!-- Conversations -->
    <div class="wa-list">
      <div class="p-2 border-bottom">
        <input type="text" class="form-control form-control-sm" placeholder="Search name or number"
          [(ngModel)]="search" [ngModelOptions]="{ standalone: true }" (keyup.enter)="loadContacts(true)" (ngModelChange)="search === '' && loadContacts(true)" />
      </div>
      <div *ngIf="loadingContacts" class="text-center p-3"><span class="spinner-border spinner-border-sm text-success"></span></div>
      <div *ngIf="!loadingContacts && contacts.length === 0" class="text-muted small p-3">No conversations yet.</div>
      <div *ngFor="let c of contacts" class="wa-contact" [class.active]="c.waContactId === selected?.waContactId"
        [class.unread]="c.unreadCount > 0" (click)="open(c)">
        <div class="d-flex justify-content-between">
          <span class="name text-truncate">{{ c.customerName || ('+' + c.customerWaId) }}</span>
          <small class="time">{{ c.lastMessageOn | date:'dd MMM, HH:mm' }}</small>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="last text-truncate">{{ c.lastMessageText }}</small>
          <span *ngIf="c.unreadCount > 0" class="wa-pill new">{{ c.unreadCount }}</span>
        </div>
      </div>
    </div>

    <!-- Thread -->
    <div class="wa-thread-pane">
      <div *ngIf="!selected" class="wa-empty text-muted">Select a conversation</div>

      <ng-container *ngIf="selected">
        <div class="wa-thread-head">
          <button class="btn btn-sm btn-light me-2 wa-back" (click)="closeThread()" title="Back to conversations">
            <i class="fa fa-arrow-left"></i>
          </button>
          <div class="me-auto">
            <div class="fw-semibold">{{ selected.customerName || ('+' + selected.customerWaId) }}</div>
            <small class="text-muted">+{{ selected.customerWaId }}</small>
          </div>
          <span class="wa-pill" [class.off]="!selected.isWindowOpen"
            title="Meta allows free-text replies only within 24 hours of the customer's last message">
            {{ selected.isWindowOpen ? ('Reply window open · ' + windowHoursLeft() + 'h left') : 'Reply window closed · template only' }}
          </span>
        </div>

        <div class="wa-thread" #thread>
          <div *ngIf="loadingMessages" class="text-center p-3"><span class="spinner-border spinner-border-sm text-success"></span></div>
          <div *ngFor="let m of messages; trackBy: trackById" class="wa-row" [class.out]="m.direction === 'OUT'">
            <div class="wa-bubble" [class.failed]="m.status === 'failed'">
              <div *ngIf="m.msgType === 'template'" class="tpl-name"><i class="fa fa-file-alt"></i> {{ m.templateName }}</div>
              <!-- Attachment: fetched from Meta on demand (see loadMedia) -->
              <div *ngIf="m.mediaId" class="wa-media" [ngSwitch]="m.msgType">
                <ng-container *ngIf="media[m.waMessageId] as v; else notLoaded">
                  <div *ngIf="v.loading" class="media-placeholder"><span class="spinner-border spinner-border-sm text-success"></span></div>
                  <button *ngIf="v.error" type="button" class="media-error" (click)="loadMedia(m)" title="Try again">
                    <i class="fa fa-exclamation-circle"></i> {{ v.error }}
                  </button>
                  <ng-container *ngIf="v.url">
                    <img *ngSwitchCase="'image'" [src]="v.url" class="media-img" alt="image" (click)="openInNewTab(v.url)" title="Open full size" />
                    <img *ngSwitchCase="'sticker'" [src]="v.url" class="media-sticker" alt="sticker" />
                    <video *ngSwitchCase="'video'" [src]="v.url" class="media-img" controls autoplay></video>
                    <audio *ngSwitchCase="'audio'" [src]="v.url" controls></audio>
                  </ng-container>
                </ng-container>
                <ng-template #notLoaded>
                  <button *ngIf="m.msgType === 'video'" type="button" class="media-chip" (click)="loadMedia(m)">
                    <i class="fa fa-play-circle"></i> Play video
                  </button>
                </ng-template>
                <button *ngIf="m.msgType === 'document'" type="button" class="media-chip" (click)="downloadDocument(m)"
                  [disabled]="media[m.waMessageId]?.loading" title="Download">
                  <i class="fa fa-file-alt"></i>
                  <span class="text-truncate">{{ m.body || 'Document' }}</span>
                  <i class="fa fa-download ms-auto"></i>
                </button>
              </div>
              <div class="text">{{ bubbleText(m) }}</div>
              <div class="meta">
                <span *ngIf="m.direction === 'OUT' && sourceLabel(m)" class="src">{{ sourceLabel(m) }}</span>
                {{ m.messageOn | date:'dd MMM, HH:mm' }}
                <ng-container *ngIf="m.direction === 'OUT'">
                  <span *ngIf="m.status === 'sent'" class="tick">✓</span>
                  <span *ngIf="m.status === 'delivered'" class="tick">✓✓</span>
                  <span *ngIf="m.status === 'read'" class="tick read">✓✓</span>
                  <span *ngIf="m.status === 'failed'" class="tick fail" [title]="m.errorText || ''">⚠ failed</span>
                </ng-container>
              </div>
              <div *ngIf="m.status === 'failed' && m.errorText" class="err">{{ m.errorText }}</div>
            </div>
          </div>
        </div>

        <!-- Composer -->
        <div class="wa-compose">
          <div *ngIf="sendError" class="alert alert-danger py-1 px-2 mb-2 small">{{ sendError }}</div>

          <div *ngIf="selected.isWindowOpen" class="d-flex gap-2">
            <textarea class="form-control" rows="2" placeholder="Type a reply… (Enter to send, Shift+Enter for a new line)"
              [(ngModel)]="replyText" [ngModelOptions]="{ standalone: true }" (keydown.enter)="onEnter($event)"></textarea>
            <button class="btn btn-success align-self-end" [disabled]="!canSend" (click)="send()">
              <span *ngIf="sending" class="spinner-border spinner-border-sm"></span>
              <i *ngIf="!sending" class="fa fa-paper-plane"></i>
            </button>
          </div>

          <div *ngIf="!selected.isWindowOpen">
            <select class="form-select form-select-sm mb-2" [ngModel]="selectedTemplate?.name || ''"
              (ngModelChange)="pickTemplate($event)" [ngModelOptions]="{ standalone: true }">
              <option value="" disabled>Choose an approved template…</option>
              <option *ngFor="let t of templates" [value]="t.name">{{ t.name }} ({{ t.language }})</option>
            </select>
            <ng-container *ngIf="selectedTemplate">
              <div class="d-flex gap-2 flex-wrap mb-2">
                <input *ngFor="let v of templateValues; let i = index" type="text" class="form-control form-control-sm tpl-input"
                  [placeholder]="'Value ' + (i + 1)" [(ngModel)]="templateValues[i]" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div class="tpl-preview small mb-2">{{ templatePreview() }}</div>
              <button class="btn btn-success btn-sm" [disabled]="!canSend" (click)="send()">
                <span *ngIf="sending" class="spinner-border spinner-border-sm me-1"></span>Send template
              </button>
            </ng-container>
            <div *ngIf="templates.length === 0" class="small text-muted">No approved templates for this number yet. Create one on the WhatsApp Template page.</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
